import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import $ from "jquery";
import SettingsPopUp from "./SettingsPopUp.js";
import { confirmAlert } from "react-confirm-alert"; // Import

const SettingsModusZeitTable = (props) => {
  const { t } = useTranslation();

  let link = localStorage.getItem("link");

  let data = props.data;
  let type = props.type;

  const [modusZeits, setModusZeits] = useState();
  const [popUpShow, setPopUpShow] = useState(false);
  const [currentModusZeitData, setCurrentModusZeitData] = useState();
  const popUpContainer = useRef(null);
  const [top, setTop] = useState(null);

  const openChild = () => {
    const scrollTop = props.getScrollTop();
    setTop(scrollTop + 20);
  };

  const closeChild = () => setTop(null);
  useEffect(() => {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("JWT");
  }, [localStorage.getItem("JWT")]);

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    await axios
      .get(link + "/api/" + type + "/mode-timer?elementId=" + data.id)
      .then((response) => {
        setModusZeits(response.data);
      });
  }

  $(document).on("click", function (e) {
    if (
      (popUpContainer.current && e.target.id == "cancelSubmitButton") ||
      (popUpContainer.current &&
        !popUpContainer.current.contains(e.target) &&
        e.target.id != "settings-icon" &&
        !$(e.target).is(".settings-item") &&
        !$(e.target).children().hasClass("settings-item") &&
        !$(e.target).hasClass("select-icon") &&
        !$(e.target).parents(".rc-time-picker-panel").length == 1 &&
        !$(e.target).hasClass("rc-time-picker-clear") &&
        !$(e.target).hasClass("rc-time-picker-clear-icon") &&
        e.target.id != "pop-up-button")
    ) {
      setPopUpShow(false);
      closeChild();
    }
  });

  function editCreateModusZeit(modusZeitData, elementId) {
    modusZeitData.elementId = elementId;
    setCurrentModusZeitData(modusZeitData);
    setPopUpShow(true);
    openChild();
  }

  const deleteModusZeit = (modusZeitData) => {
    let timerId = modusZeitData.timerId;

    confirmAlert({
      message: t("allgemein.bestaetigen"),
      buttons: [
        {
          label: t("allgemein.ja"),
          onClick: () =>
            axios
              .delete(link + "/api/" + type + "/mode-timer?timerId=" + timerId)
              .then((response) => {
                getData();
              })

              .catch((error) => {}),
        },
        {
          label: t("allgemein.nein"),
        },
      ],
    });
  };

  function modusZeitsList() {
    let modusZeitsList = [];

    for (let i = 0; i < modusZeits.length; i++) {
      const daysOfWeek = [
        t("allgemein.tageKurz.Sunday"),
        t("allgemein.tageKurz.Monday"),
        t("allgemein.tageKurz.Tuesday"),
        t("allgemein.tageKurz.Wednesday"),
        t("allgemein.tageKurz.Thursday"),
        t("allgemein.tageKurz.Friday"),
        t("allgemein.tageKurz.Saturday"),
      ];
      const chosenDaysOfWeek = modusZeits[i].weekdays
        .map(function (v, i) {
          return daysOfWeek[v];
        })
        .join(",");

      modusZeitsList.push(
        <tr key={"key_" + i}>
          <td>
            {modusZeits[i].startTime} - {modusZeits[i].endTime}
          </td>
          <td>{chosenDaysOfWeek}</td>
          <td>
            {modusZeits[i].mode == 0 && t("lot.modes.Automatic")}
            {modusZeits[i].mode == 1 && t("lot.modes.ManualFree")}
            {modusZeits[i].mode == 2 && t("lot.modes.ManualOccupied")}
          </td>
          <td>
            <button
              className="button"
              id="pop-up-button"
              style={{ width: "100px" }}
              onClick={() => editCreateModusZeit(modusZeits[i], data.id)}
            >
              {t("allgemein.bearbeiten")}
            </button>
            <button
              className="button"
              id="pop-up-button"
              style={{ width: "100px", marginLeft: "0" }}
              onClick={() => deleteModusZeit(modusZeits[i])}
            >
              {t("allgemein.loeschen")}
            </button>
          </td>
        </tr>
      );
    }

    return <tbody>{modusZeitsList}</tbody>;
  }

  function popUpChange() {
    getData();
    setPopUpShow(false);
    closeChild();
  }

  return (
    <>
      {popUpShow == true && top !== null && (
        <div ref={popUpContainer}>
          {
            <SettingsPopUp
              popUpType={"modusZeit"}
              type={type}
              data={currentModusZeitData}
              onChange={popUpChange}
              top={top}
            >
              {" "}
            </SettingsPopUp>
          }
        </div>
      )}
      <div className="settings-groups">
        <div className="settings-name">
          {t("allgemein.modus")} {t("allgemein.zeitsteuerung")}
        </div>
        <table id="barrierTable">
          <thead>
            <tr>
              <th>{t("allgemein.zeitraum")}</th>
              <th>{t("allgemein.wochentage")}</th>
              <th>{t("allgemein.modus")}</th>
              <th>
                <button
                  className="button"
                  id="pop-up-button"
                  style={{ width: "50px" }}
                  onClick={() => editCreateModusZeit({}, data.id)}
                >
                  {t("allgemein.neu")}
                </button>
              </th>
            </tr>
          </thead>
          {modusZeits && modusZeitsList()}
        </table>
      </div>
    </>
  );
};

export default SettingsModusZeitTable;
